module.exports = __webpack_public_path__ + "img/index-desc-4-pic.c5c4b93e.png";